module.exports = __webpack_public_path__ + "img/团队空间.d1cc36d7.svg";